<template>
    <section id="first_page_cont" class="page_cont">
        <!--
        {{/*START CAROUSEL */ }}
        <div id="carousel_cont" ref="carousel_first_page" v-if="this.slides.length">
            <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval=this.interval
            controls
            indicators
            fade
            background="transparent"

            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            >
            <span  v-for="(slide_,i) in this.slides" :key="i.toString()+slide.caption">
                <b-carousel-slide
                :caption="slide_.caption"
                text=""
                :img-src="slide_.image"
                >
                <div class="carousel-text-cont">
                    <div v-for="(line,i) in slide_.text.split('+')" :key="line+i.toString()">
                        <p>{{line}}</p>
                    </div>
                </div>
              
                <div class="card_social_cont">
                        <div class="for_social" v-for="(social_key,j) in Object.keys(slide_).filter(f=>f.includes('social_'))" :key="i.toString()+social_key+j.toString()">
                        <div :class="social_key!=='' ?'for_social_sub' :'for_social_pub_empty'" v-if="slide_[social_key]!==''"> <a :href="slide_[social_key]" target="_blank"><font-awesome-icon :icon="`fa-brands fa-${social_key.replace('social_','')}`"/> </a> </div> 
                        </div>
                    </div>
                </b-carousel-slide>
            </span>
            <div id="down_arrow_cont">
            <div class="arrow bounce" id="arrow1">
            <a class="fa fa-arrow-down fa-2x" href="#first_page_text"></a>
        </div>
        <div class="arrow bounce" id="arrow2">
            <a class="fa fa-arrow-down fa-2x" id="arrow2" href="#first_page_text"></a>
        </div>
        </div>
           
            </b-carousel>

        </div>
        /*END CAROUSEL */ }}
        -->
        <div id="first_page_text">
            <div id="text_hulahoop_cont" class="text_el">
                <h1 id="hulahoop_title" class="title_">Che cos'è Hula Hoop?</h1>
                <div id="hulahoop_text" class="body_">
                    <div>
                    <img class="gif" id="cipeciop_gif1" alt="" src="cip_e_ciop_gif1.gif"/>
                    </div>
                    <div class="text_">
                    <p>Una <em>location perfetta</em> per festeggiare ogni tipo di evento: <em>Hula Hoop ti lascerà un ricordo indimenticabile</em>.</p>
                    <p>Originale e accogliente, ti permetterà di sentirti a casa.</p>
                    <p>Compleanni, eventi a tema, baby shower e tanto altro.</p>
                    <p>Organizziamo <em>feste su misura</em> senza farci sfuggire nessun dettaglio.</p>
                    <p>Allestimenti e animazione curati  professionalmente <br>da <em>Group Animation & Boing Party</em> ti condurranno <em>all'insegna del divertimento</em>.</p>
                    <button class="link_btn" v-on:click="go_to_page('Servizi')">Corri a scoprire di più!</button>
                    </div>
                </div>
            </div>

            <div id="text_animationgroup_cont" class="text_el">
                <h1 id="groupanimation_title"  class="title_">Con chi collabora?</h1>
                <div id="groupanimation_text"  class="body_">
                    <div>
                        <img class="gif" id="cipeciop_gif2" alt="" src="cip_e_ciop_gif2.gif"/>

                    </div>
                    <div>
                    <p>Group Animation & Boing party di Angeliana Anelli</p>
                    <p>sito a Corato in via Sant'Elia 99.</p>
                    <p>Vai alla sezione <button class="link_btn" v-on:click="go_to_page('Team')">Team</button> per saperne di più!</p>
                </div>
                    
                </div>
            </div>


            <div id="text_servizi_cont" class="text_el">
                <h1 id="servizi_title"  class="title_">Dove trovarci</h1>
                <div id="servizi_text"  class="body_" style="text-align: center;">
                    <div>
                        <img class="gif" id="pinguino_gif1" alt="" src="pinguino_gif1.gif"/>

                    </div>

                    <div>
                    <div>
                        <p>
                           <em style="margin-left: -60px;" >Città:</em>
                            Corato, BA
                        </p>
                        <p>
                           <em  style="margin-left: -10px;">Location:</em>
                            Via Alemanni 68
                        </p>
                        <p>
                            <em   style="margin-left: -35px;">Info point:</em>
                            Via Cilea 12
                        </p>
                    </div>
                    Vai alla sezione <button class="link_btn" v-on:click="go_to_page('Contatti')">Contatti</button> per saperne di più!
                    
                </div>
                    <div id="map_cont">
                        <div id="tile_handler_cont">
                            <b-dropdown id="tile_dropdown" :text=" 'Stile: '+this.tile_selected" ref="tile_dropdown" class="m-md-2" variant="danger">
                                <button :class="tile_selected===key ?'tile_opt_active' :'tile_opt'" v-for="(key,i) in Object.keys(this.map_tiles)" :key="i.toString()+key" @click="update_selected_tile(key)">{{key}}</button><br>

                            </b-dropdown>
                        </div>
                        <div id="map"></div>
                    </div>
                </div>
                    

            </div>
        </div>
        

        
    </section>
</template>

<script>

export default{
    
    name:"FirstPage",
    props:{},
    data(){
        return{
            interval:4000,
            slide:0,
            sliding:null,
            slides:[],
            map:[],
            map_tiles:{
                "Satellite":"http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                "Standard":'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
                
            },
            tile_selected:"Standard",
            data_loaded:false
        }
    },
    mounted(){
         /*
        setTimeout(() => {
                this.scrollTo();
                }, "100");
       
       //read home slides (cannot be done in a generalized function, as e.g. "this.slide" is not modified)
       fetch("home_slides.json")
        .then((res)=>res.json())
        .then((json)=>{
            this.slides=json["slides"]
        }).catch((e)=>console.log("ERR", e))
        */
       this.$parent.track_page("Home")


       this.slides= this.$parent.firebase_data["slides"]["slides"]
        //console.log(this.slides)

       //init map
        this.initMap()



        
    },
    methods:{
        scrollTo() {
      this.$refs.carousel_first_page.scrollIntoView();
    },
        onSlideStart(slide) {
        this.sliding = true

      },
      onSlideEnd(slide) {
        this.sliding = false
      },

      go_to_page(page){
        //alert("a")
        //this doesn't work because the listener must be set as a prop of a component, not in the component itself (i.e., App.vue)
        //opt for scroll approach instead
        //this.$emit('change-page-from-child',page_n)
        this.$parent.target_page = page
        window.scrollTo({top:0, left:0, behavior:"smooth"})
      },
      initMap() {
        var map = L.map('map').setView([41.14952,16.40678], 19);
       L.tileLayer(this.map_tiles[this.tile_selected], {
        maxZoom: 19,
        attribution: '© OpenStreetMap'
        }).addTo(map);

        let popup1=L.popup({closeOnClick: true, autoClose: true}).setContent("La nostra location è qui!<br>Via Alemanni, 68, Corato")
        let popup2=L.popup({closeOnClick: true, autoClose: true}).setContent("Il nostro info point è qui!<br>Via Cilea, 12, Corato")
        var icon1 = L.icon({
                iconUrl: 'balloons.png',
                iconSize: [40, 40],
                iconAnchor: [0,0],
                popupAnchor: [20,0],
            });

        var icon2 = L.icon({
                iconUrl: 'info.png',
                iconSize: [40, 40],
                iconAnchor: [15,0],
                popupAnchor: [0,0],
            });

        var marker = L.marker([41.14952,16.40678],{icon:icon1}).addTo(map).bindPopup(popup1).openPopup()
        var marker2 = L.marker([41.14952,16.40698],{icon:icon2}).addTo(map).bindPopup(popup2)
        //preserve map for destroying it after
        this.map= map

        map.on({zoom: ()=>{
            let zoom_level=map.getZoom()
            if(zoom_level===19){
                map.openPopup(popup1);
            }else{
                map.closePopup(popup1);
                try{
                    map.closePopup(popup2)
                }catch{

                }

            }

            
        }})
      },

      update_selected_tile(key){
        this.tile_selected=key
      }
            
      
    },
    watch:{
        tile_selected: function(){
            this.map.off();
            this.map.remove();
            this.initMap()
            this.$el.querySelector("#tile_dropdown__BV_toggle_").click()

        },

    }
}
</script>

<style>

        

    p{
        margin-bottom: 0px!important;
    }


    #carousel_cont{
        width: 100%;
        position: relative;
    }

    .carousel-text-cont{
        overflow-y: scroll!important;
        height:100%!important;
        max-height: 70%;
    }
    .carousel-caption h3{
        color: var(--bs-danger)!important;
        font-size: 2em!important;
        font-weight: bolder;
    }

    #first_page_text, #second_page_text{
        width: 100%;
        position: absolute;
        margin-top: 1%;
        text-align: justify;
        width: 75%;
        margin-left: 15%;
        text-justify: inter-word;
    }

    ol > li{
        width: 20px;
        height: 20px;
        margin-left: 1vw;
        margin-right: 1vw;
        margin-bottom:5vh;
        background-color: grey;
        border: 1px black solid;
        color: transparent;
        font-size: 0px;
        border-radius: 50%;
        border:transparent;
        box-shadow: rgba(0, 0, 0, 0.56) 0px 12px 7px 2px;

        transition: 500ms ease-in; /*see this.interval */



    }

    
    ol > li.active{
        width: 25px;
        height: 25px;
        margin-left: 2vw;
        margin-right: 2vw;
        background-color:rgba(231, 16, 16, 0.615);
        border: transparent;
        color: black;
        font-size: 0px;
        text-align: center;
        border-radius: 50%;
        box-shadow: rgba(125, 60, 60, 0.615) 0px 12px 7px 2px;;
        animation: glow 1s ease-in-out infinite alternate;

        


        transition: 700ms;
        border: transparent;

    }

    ol > li:hover{
        color:black;
        font-size:10px; 
    }

    ol > li.active:hover{
        color:black;
        font-size:16px; 
        margin-left: 3vw;
    }

    ol{
        margin-bottom: 70px;
    }


    

  
   

    .arrow {
    text-align: center;
    position: absolute;
    color: black;
    background-color: white;
    border-radius: 50%;
    padding: 1%;
    z-index: 999;
    border: var(--body_bg) 7px solid;
    

    }
    #arrow1{
        left:150px;
        bottom:50px;
    }

    #arrow2{
        bottom:50px;
        right:150px;
    }

    .fa-arrow-down{
        color:var(--bs-danger) ;
    } 

    .bounce {
    -moz-animation: bounce 2s infinite;
    -webkit-animation: bounce 2s infinite;
    animation: bounce 2s infinite;
    }


    #down_arrow_cont{
        width: 100%;
    }



    
    @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-30px);
    }
    60% {
        transform: translateY(-15px);
    }
    }


    .carousel-caption{
        position: absolute;
        top:5%;
    }

    .carousel-caption>p{
        margin-top: 15%;
    }

    .slide_url_cont{
        position: absolute;
        text-align: center;

        bottom: 50px;
        left:40%;
    }


    .title_{
        text-align: center;
    }

    .link_btn{
        background-color: transparent;
        border: transparent;
        color: var(--bs-primary);
        padding: 0;
        text-decoration: underline;
        cursor: pointer;
        font-size: 26px!important;
        font-weight: bold!important;
    }
    #map { height: 500px }
    .tile_opt, .tile_opt_active{
        width: 100%;
        background-color: transparent;
        border: transparent;
    }

    .tile_opt_active{
        background-color: var(--bs-danger);
        color: white;
    }
    .leaflet-popup-content-wrapper,
    .leaflet-popup-tip {
    background: var(--bs-danger);
    font-family: Ink Free;
    font-weight: bold;
    font-size: 16px;
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    color: white;
}

    #tile_handler_cont{
        position: absolute;
        z-index: 999;
        left:50px
    }
    #tile_dropdown{
        display: flex;
        flex-direction: column;
        width: 160px!important;
        background-color: white;
        margin-left:25%!important;

    }


    .text_el{
    margin-bottom: 5%;
    font-size: 25px!important;
    font-family: Gabriola;
    


}
.text_el em{
    color: var(--bs-danger)!important;
    font-style:normal;
    font-size: 26px!important;
    font-weight: bold;
}


    @media only screen and (max-width: 990px) {
        ol > li{
        margin-left: 1vw;
        margin-right: 1vw;
        margin-bottom:0vh;
     }

     .slide_url_cont{
        bottom:0px
     }
    }

 


.body_{
    text-align: center;
}

#text{
    padding: 3%;
}


    .title_{
    background: var(--bs-danger);
    margin-bottom: 1px;
    width: 100%!important;
    margin-left: 0%!important;
    border-radius: 0.5em 0.5em 0em 0em;
    color:white!important
}

.body_{
    background-color: white;
    padding:1em 2em 2em 1em;
}
    
.text_{
    position: relative;
    z-index: 2!important;
}

@media(pointer:coarse){

    @media(orientation: landscape){
    .text_el{
    margin-bottom: 5%;
    font-size: 16px!important;
    font-family: Gabriola;
    


}
.text_el em{
    color: var(--bs-danger)!important;
    font-style:normal;
    font-size: 17px!important;
    font-weight: bold!important;
}
.link_btn{
    font-size: 17px!important;
    font-weight: bold!important;

}
}



@media(orientation: portrait){
    .text_el{
    margin-bottom: 5%;
    font-size: 16px!important;
    font-family: Gabriola;
    }

    .text_el em{
    color: var(--bs-danger)!important;
    font-style:normal;
    font-size: 17px!important;
    font-weight: bold;
}
.link_btn{
    font-size: 17px!important;
    font-weight: bold!important;

}

}

}





#cipeciop_gif1{
        position: relative;
        z-index:1;
        scale:1;
        float:left;
        left:-25px;
        width: 5em;
        top:-26px;

        
    }

#cipeciop_gif2, #pinguino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 7em;
        top:-26px;
        left: 0px;

        
    }


@media only screen and (max-width:1400px){
#cipeciop_gif1{
        position: relative;
        z-index:1;
        left:-35px;
       top:-36px;
        scale:0.9;
        width: 5em;

    }
    #cipeciop_gif2, #pinguino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 7em;
        top:-26px;
        left: 0px;

        
    }

    

}

@media only screen and (max-width:1000px){
#cipeciop_gif1{
        position: relative;
        z-index:1;
        left:-25px;
       top:-27px;
        scale:1;
        width: 5em

    }
    #cipeciop_gif2, #pinguino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 100px;
        top:-26px;
        left: 0px;

        
    }
    


}

@media(pointer:coarse){
    @media(orientation:landscape){
        #cipeciop_gif1{
        position: relative;
        z-index:1;
        left:-16px;
        top:-17px;
        scale:1;
        width: 5em!important
    }
    #cipeciop_gif2, #pinguino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 7em!important;
        top:-10px;
        left: 0px;

        
    }
    
    .carousel-text-cont{
        overflow-y: scroll!important;
        height:100%!important;
        max-height: 60%!important;
        font-size: 90%!important;
    }
    


    }

    @media(orientation:portrait){
        #cipeciop_gif1{
            position: relative;
        z-index:1;
        left:-16px;
        top:-17px;
        scale:1;
        width: 5em!important;

    }
    .carousel-text-cont{
        overflow-y: scroll!important;
        height:100%!important;
        max-height: 50%!important;
        font-size: 90%!important;
    }

  
    }

    #cipeciop_gif2, #pinguino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 7em!important;
        top:-10px;
        left: 0px;

        
    }

    #second_page_text{
        margin-left: 16%!important;
    }

    

}


</style>
